var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"my-like-empty"},[_c('img',{attrs:{"src":require("../../assets/images/mypooq/icon-error-74.png"),"alt":"에러 아이콘"}}),_c('p',{attrs:{"tabindex":"0"},domProps:{"innerHTML":_vm._s(_vm.text)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }